import { memo } from 'react';
import { errToast, succToast, ValidateEmail } from '@/utils.js';
import CodeForm from './forms/codeForm';
import { VerifyResetCode } from '@/api/endpoints';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

const VerifyCode = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const {state} = useLocation()


    const hanldeVerifyCode = (e, data) => {
        e?.preventDefault()

        data.setLoading(true)
        VerifyResetCode({email :state?.email, otp :data.code?.value}).then(res => {
            succToast(t("Code is verified successfully"))
            navigate('/auth/reset-password', { state: {  email: state?.email , code: data.code?.value } })
        }).catch(() => {
        }).finally(_ => {
            data.setLoading(false)
        })   
    }

    return (
        <CodeForm onSubmit={hanldeVerifyCode} />

    );
}

export default memo(VerifyCode);

